import { Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Pipeline1 from "./pages/Pipeline1";
import Pipeline2 from "./pages/Pipeline2";
import Result from "./pages/Result";

function InteriorDesignAIApp() {
  return (
    <div className="interior-ai-root">
      <Navbar />
      <Routes>
        <Route index element={<Home />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="pipeline1" element={<Pipeline1 />} />
        <Route path="pipeline2" element={<Pipeline2 />} />
        <Route path="result" element={<Result />} />
      </Routes>
    </div>
  );
}

export default InteriorDesignAIApp;
